import { SitemapCheckboxControl } from '../_components/checkbox';
import { ContentIdPicker } from '../_components/content-id-picker';
import { LinkedPaginationPanel } from '../_components/linked-pagination-panel';
import { PostTypeLabelPanel } from '../_components/post-type-label-panel';
import { parsePostTypeSelection } from '../_components/post-type-utils.mjs';
import { PostTypeSelect } from '../_components/select-cpt';
import metadata from '../../../blocks/content/block.json';

//  Import core block libraries
const { __ } = wp.i18n;
const { InspectorControls, useBlockProps } = wp.blockEditor;
const {
	PanelBody,
	PanelRow,
	TextControl,
	//RadioControl,
	SelectControl,
	//ServerSideRender
} = wp.components;
const { registerBlockType } = wp.blocks;
const ServerSideRender = wp.serverSideRender;
const { applyFilters } = wp.hooks;

const { useMemo } = wp.element;
/**
 * Register block
 */
export default registerBlockType(metadata.name, {
	apiVersion: metadata.apiVersion,
	title: metadata.title,
	icon: metadata.icon,
	keywords: [
		__('Sitemap', 'simple-sitemap'),
		__('Single', 'simple-sitemap'),
		__('HTML Sitemap', 'simple-sitemap'),
	],
	category: metadata.category,
	example: metadata.example,
	supports: metadata.supports,
	edit: function Edit(props) {
		const blockProps = useBlockProps({
			className: 'simple-sitemap-editor-preview-wrapper',
		});
		const {
			attributes: {
				id,
				show_excerpt,
				show_label,
				links,
				page_depth,
				render_tab,
				block_post_types,
				order,
				orderby,
				target_blank,
				post_type_label,
				include,
				exclude,
				paginate,
				page_size,
			},
			//className,
			setAttributes,
			//isSelected,
			attributes,
		} = props;

		function updateToggleTabs(isChecked) {
			setAttributes({ render_tab: isChecked });
		}

		function updateExcerpt(isChecked) {
			setAttributes({ show_excerpt: isChecked });
		}

		function updateShowLabel(isChecked) {
			setAttributes({ show_label: isChecked });
		}

		function updateLinks(isChecked) {
			setAttributes({ links: isChecked });
		}

		const postTypesParse = useMemo(() => {
			return parsePostTypeSelection(block_post_types);
		}, [block_post_types]);
		const searchablePostTypes = useMemo(
			() => postTypesParse.map(({ value }) => value).filter(Boolean),
			[postTypesParse]
		);

		const selectPostTypes = applyFilters(
			'sitemap-post-types-select',
			<PostTypeSelect
				setAttributes={setAttributes}
				block_post_types={block_post_types}
				options={[
					{ value: 'post', label: 'Post' },
					{ value: 'page', label: 'Page' },
				]}
			/>,
			props
		);

		const postTypesHelpLabel = applyFilters(
			'post-types-help-label',
			<PanelRow className="panel-row-help-label">
				<p
					style={{
						marginTop: '-20px',
						fontSize: '13px',
						fontStyle: 'italic',
						marginLeft: '2px',
					}}
				>
					List{' '}
					<a
						href="https://wpgoplugins.com/plugins/simple-sitemap-pro/#post-types"
						target="_blank"
						rel="noreferrer"
					>
						more
					</a>{' '}
					post types
				</p>
			</PanelRow>,
			props
		);

		const sitemapGeneralSettings = applyFilters(
			'sitemap-general-settings',
			'',
			props
		);
		const sitemapGeneralStyles = applyFilters(
			'sitemap-general-styles',
			'',
			props
		);
		const sitemapFeaturedImage = applyFilters(
			'sitemap-featured-image',
			'',
			props
		);
		const sitemapTabControls = applyFilters(
			'sitemap-tab-controls',
			'',
			props
		);
		const sitemapSectionSettings = applyFilters(
			'sitemap-section-settings',
			'',
			props
		);
		return [
			<InspectorControls key="simple-sitemap-block-controls">
				<PanelBody title={__('General Settings', 'simple-sitemap')}>
					<PanelRow>{selectPostTypes}</PanelRow>
					{postTypesHelpLabel}
					<PanelRow className="simple-sitemap order">
						<SelectControl
							label="Orderby"
							value={orderby}
							options={[
								{ label: 'Title', value: 'title' },
								{ label: 'Date', value: 'date' },
								{ label: 'ID', value: 'ID' },
								{ label: 'Author', value: 'author' },
								{ label: 'Name', value: 'name' },
								{ label: 'Modified', value: 'modified' },
								{ label: 'Menu Order', value: 'menu_order' },
								{ label: 'Random Order', value: 'rand' },
								{
									label: 'Comment Count',
									value: 'comment_count',
								},
							]}
							onChange={(value) => {
								setAttributes({ orderby: value });
							}}
						/>
						<SelectControl
							label="Order"
							value={order}
							options={[
								{ label: 'Ascending', value: 'asc' },
								{ label: 'Descending', value: 'desc' },
							]}
							onChange={(value) => {
								setAttributes({ order: value });
							}}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={show_label}
							label="Show post type label"
							updateCheckbox={updateShowLabel}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={show_excerpt}
							label="Show excerpt"
							updateCheckbox={updateExcerpt}
						/>
					</PanelRow>
					<PanelRow className="simple-sitemap general-chk">
						<SitemapCheckboxControl
							value={links}
							label="Enable sitemap links"
							updateCheckbox={updateLinks}
						/>
					</PanelRow>
					{links && (
						<PanelRow className="simple-sitemap general-chk">
							<div style={{ margin: '0 0 5px 1rem' }}>
								<SitemapCheckboxControl
									value={target_blank}
									label={__(
										'Open links in new tab',
										'simple-sitemap'
									)}
									updateCheckbox={(isChecked) => {
										setAttributes({
											target_blank: isChecked,
										});
									}}
								/>
							</div>
						</PanelRow>
					)}
					{sitemapGeneralSettings}
				</PanelBody>
				<PanelBody
					title={__('Content Selection', 'simple-sitemap')}
					initialOpen={false}
				>
					<ContentIdPicker
						label={__('Exclude content', 'simple-sitemap')}
						help={__(
							'Enter a comma-separated list of post or page IDs to leave out. Manual entry also supports private content.',
							'simple-sitemap'
						)}
						value={exclude}
						postTypes={searchablePostTypes}
						onChange={(value) => setAttributes({ exclude: value })}
					/>
					<ContentIdPicker
						label={__('Include only content', 'simple-sitemap')}
						help={__(
							'Enter a comma-separated list of post or page IDs. Other items will be hidden. Manual entry also supports private content.',
							'simple-sitemap'
						)}
						value={include}
						postTypes={searchablePostTypes}
						onChange={(value) => setAttributes({ include: value })}
					/>
				</PanelBody>
				{sitemapSectionSettings}
				<LinkedPaginationPanel
					id={id}
					idPrefix="sitemap"
					paginate={paginate}
					pageSize={page_size}
					setAttributes={setAttributes}
					help={__(
						'Loads a bounded set of entries per request. Hierarchical pages use a flat list so entries are not duplicated across pages.',
						'simple-sitemap'
					)}
					entriesLabel={__('Entries per page', 'simple-sitemap')}
				/>
				<PostTypeLabelPanel
					postTypes={postTypesParse}
					postTypeLabels={post_type_label}
					setAttributes={setAttributes}
				/>
				{sitemapGeneralStyles}
				{sitemapFeaturedImage}
				<PanelBody
					title={__('Tab Settings', 'simple-sitemap')}
					initialOpen={false}
				>
					<PanelRow className="simple-sitemap">
						<SitemapCheckboxControl
							value={render_tab}
							label="Enable tabs"
							updateCheckbox={updateToggleTabs}
						/>
					</PanelRow>
					{sitemapTabControls}
				</PanelBody>
				<PanelBody
					title={__('Page Settings', 'simple-sitemap')}
					initialOpen={false}
				>
					<PanelRow className="simple-sitemap">
						<p>Affects sitemap pages only.</p>
					</PanelRow>
					<PanelRow className="simple-sitemap">
						<TextControl
							type="number"
							label="Page indentation"
							min="0"
							max="5"
							help="Leave at zero for auto-depth"
							value={page_depth}
							onChange={(value) => {
								setAttributes({
									page_depth: parseInt(value),
								});
							}}
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>,
			<div
				key="simple-sitemap-server-side-render-component"
				{...blockProps}
			>
				<ServerSideRender
					block="wpgoplugins/simple-sitemap-block"
					attributes={attributes}
				/>
			</div>,
		];
	},
	save() {
		return null;
	},
});
